import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { FC, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

type ResetButtonProps = Readonly<{
  className: string;
  isEnabled: boolean;
  onResetClicked: () => void;
}>;

export const ResetButton: FC<ResetButtonProps> = ({ isEnabled, onResetClicked, className }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  return (
    <a
      onClick={() => {
        logAnalytics.trackEvent(logAnalyticsCategory, 'Reset tab from shortcut');
        onResetClicked();
      }}
      className={classNames('btn text-uppercase', { disabled: !isEnabled }, className)}
    >
      <FormattedMessage id="form.buttons.Reset" />
    </a>
  );
};
